<template>
  <div class="svg__custom-boxmain" ref="scrollV">
    <Header :logoUrl="logoUrl" />
    <button
      v-if="activeSlug && !pinVisible"
      class="btn-locate-pin"
      @click="scrollToActivePin"
    >
      📍 Ver ubicación
    </button>
    <div style="width: 100%">
      <div class="svg__box" ref="scrollH">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 4794 4716"
          xml:space="preserve"
          @click="showCoordinatesOnConsole"
        >
          <image
            ref="svgImage"
            width="100%"
            height="4716"
            xlink:href="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/masterplan/Plan_Maestro_2026_progressive.jpg"
            @load="scrollToActivePin"
          ></image>
          <polygon
            v-for="(location, index) in locations"
            :key="index"
            :points="location.coords"
            class="polygon__map-main"
            :name="`${location.name}`"
          />
          <path  v-for="(locat, index) in locations"
            :key="`${index}-pin`"
            class="pin-element"
            :class="{ 'pin-active': locat.slug === activeSlug }"
            :id="locat.slug === activeSlug ? 'active-pin' : undefined"
            :d="locat.pin"
            :fill="locat.slug === activeSlug ? '#e63946' : '#152541'"
          />
        </svg>
        <tippy
          theme="toolMapMain"
          trigger="mouseenter"
          multiple="true"
          arrow="true"
          :placement="`${location.position}`"
          interactive="true"
          animation="fade"
          allowHTML="true"
          v-for="(location, index) in locations"
          :key="index"
          :to="`${location.name}`"
        >
        
          <tooltip-map-main :location="location" />
        </tippy>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../core/Header";
import TooltipMapMain from "../core/TooltipMapMain";
import { locationsData } from "../../utils/data_map_home.js";
import {
  faXmark,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
export default {
  name: "Home",
  data() {
    return {
      logoUrl: require("../../assets/img/core/logo.png"),
      locations: locationsData,
      name: "",
      closeIcon: faXmark,
      downIcon: faArrowDown,
      upIcon: faArrowUp,
      leftIcon: faArrowLeft,
      rightIcon: faArrowRight,
      coordinates: [], // Lista para almacenar las coordenadas (solo en memoria)
      pinVisible: false,
      pinObserver: null,
      autoScrollDone: false,
    };
  },
  components: {
    Header,
    TooltipMapMain,
  },
  watch: {
    pinVisible(visible) {
      if (!visible && !this.autoScrollDone) {
        this.autoScrollDone = true;
        this.scrollToActivePin();
      }
    },
  },
  computed: {
    activeSlug() {
      return this.$route.query.slug || null;
    },
  },
  methods: {
    scrollToActivePin() {
      if (!this.activeSlug) return;
      const pin = document.getElementById('active-pin');
      if (!pin) return;
      const scrollV = this.$refs.scrollV;
      const scrollH = this.$refs.scrollH;
      if (!scrollV || !scrollH) return;
      const rect = pin.getBoundingClientRect();
      const containerVRect = scrollV.getBoundingClientRect();
      const containerHRect = scrollH.getBoundingClientRect();
      const top = scrollV.scrollTop + rect.top - containerVRect.top - scrollV.clientHeight / 2 + rect.height / 2;
      const left = scrollH.scrollLeft + rect.left - containerHRect.left - scrollH.clientWidth / 2 + rect.width / 2;
      scrollV.scrollTo({ top, behavior: 'smooth' });
      scrollH.scrollTo({ left, behavior: 'smooth' });
      this.observeActivePin();
    },
    observeActivePin() {
      if (!this.activeSlug) return;
      const pin = document.getElementById('active-pin');
      if (!pin) return;
      if (this.pinObserver) this.pinObserver.disconnect();
      this.pinObserver = new IntersectionObserver(
        ([entry]) => { this.pinVisible = entry.isIntersecting; },
        { threshold: 0.5 }
      );
      this.pinObserver.observe(pin);
    },
    showCoordinatesOnConsole(event) {
          const svg = event.target.closest('svg');
          const point = svg.createSVGPoint();

          point.x = event.clientX;
          point.y = event.clientY;

          const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

          // Guardar coordenadas en la lista
          this.coordinatesList.push(`${svgPoint.x.toFixed(2)},${svgPoint.y.toFixed(2)}`);

          // Imprimir TODAS las coordenadas en un string
          //const output = this.coordinatesList.join(' ');
          //console.log(output);
        },
  },
  mounted() {
    // Fallback: si la imagen ya estaba en caché y @load no dispara, intentamos igual
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.scrollToActivePin();
        this.observeActivePin();
      });
    });
  },
  beforeDestroy() {
    if (this.pinObserver) this.pinObserver.disconnect();
  },
};
</script>

<style lang="css" scoped>
.btn-locate-pin {
  position: fixed;
  top: 80px;
  left: 16px;
  z-index: 100;
  background: #e63946;
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  animation: fadeInUp 0.25s ease;
}

.btn-locate-pin:hover {
  background: #c1121f;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateX(-12px); }
  to   { opacity: 1; transform: translateX(0); }
}

.pin-active {
  transform-box: fill-box;
  transform-origin: bottom center;
  animation: pinPulse 1.2s ease-in-out infinite;
}

@keyframes pinPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.35);
    opacity: 0.75;
  }
}
</style>
